<template>
  <b-modal v-model="showModal"
           @ok="saveNewDateTime"
           :ok-disabled="state.isUpdating">
    <div slot="modal-title">
      {{ $t('message.my_reservations.change_date_time') }}
    </div>
    <section>
      <label>{{ $t('message.my_reservations.cleaning_date') }}:&nbsp;&nbsp;</label>
      <div class="row">
        <div class="col-md-8 col-7 p-0">
          <div v-if="selectedDate">
            <input type="text"
                   class="form-control -date-picker input-jumbo"
                   v-pikaday="selectedDate"
                   ref="cleaningDate" readonly>
          </div>
        </div>
        <div class="col-md-4 col-5 pr-0">
          <div v-if="selectedTime">
            <div class="select-jumbo">
              <select v-model="selectedTime">
                <option :value="time" v-for="time in times">{{ time }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div slot="modal-cancel" @click="showModal = false">{{ $t('message.button.cancel') }}</div>
    <div slot="modal-ok">{{ $t(isUpdating) }}</div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        showModal: false,
        orderId: null,
        selectedDate: null,
        selectedTime: null,
        times: ['07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
          '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30',
          '17:00', '17:30', '18:00', '18:30', '19:00', '19:30']
      }
    },
    computed: {
      ...mapGetters({
        isUpdating: 'orderDetail/getIsUpdating',
        state: 'orderDetail/getState'
      })
    },
    watch: {
      isUpdating () {
        if (!this.state.isUpdating) {
          this.showReviseDateTimeModal(false)
        }
      }
    },
    methods: {
      showReviseDateTimeModal (status) {
        this.showModal = status
      },
      setSelectedDateTime (id, date, time) {
        this.orderId = id
        this.selectedDate = date
        this.selectedTime = time
      },
      saveNewDateTime (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        const arr = this.$refs.cleaningDate.value.split('/')
        const cleaningDate = arr[2] + '-' + arr[1] + '-' + arr[0]
        const cleaningDateTime = cleaningDate + ' ' + this.selectedTime + ':00'
        const submitData = {
          order_id: this.orderId,
          cleaning_datetime: cleaningDateTime
        }
        this.$store.dispatch('orderDetail/ADD_REVISE_DATE_TIME', submitData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ReviseDateTimeModal.vue